/**
 * Get assistive label for masked input field per the following guidelines:
 * 	Label should read <label> <prefix label> <suffix label>
 *  If prefix label and/or suffix label are replaced by icons, do not read those
 *
 * @export
 * @param {string} label
 * @param {string} assistiveText
 * @param {string} prefixLabel
 * @param {string} suffixLabel
 * @param {string} [prefixIcon=null]
 * @param {string} [suffixIcon=null]
 * @returns {string}
 */
function getAriaLabelForMaskedInput(label, assistiveText, prefixLabel, suffixLabel, prefixIcon = null, suffixIcon = null) {
    let resultLabel = label || assistiveText;
    if (prefixLabel && !prefixIcon) {
        resultLabel += ` ${prefixLabel}`;
    }
    if (suffixLabel && !suffixIcon) {
        resultLabel += ` ${suffixLabel}`;
    }
    return resultLabel;
}
function getAriaLabelledByForMaskedInput(labelId, prefixId, suffixId, prefixLabel, suffixLabel, prefixIcon = null, suffixIcon = null) {
    let resultLabel = labelId;
    if (prefixLabel && !prefixIcon) {
        resultLabel += ` ${prefixId}`;
    }
    if (suffixLabel && !suffixIcon) {
        resultLabel += ` ${suffixId}`;
    }
    return resultLabel;
}
/**
 * Whether or not to use aria-label instead of aria-labelledby.
 * Use aria-label if there is no prefix or suffix or there is a suffix button.
 */
function useAriaLabelForAssistiveText(label, prefixLabel, suffixLabel, suffixIcon = null, isSuffixEditable = false) {
    return (!label &&
        !prefixLabel &&
        (!suffixLabel || (suffixIcon && isSuffixEditable)));
}

export { getAriaLabelledByForMaskedInput as a, getAriaLabelForMaskedInput as g, useAriaLabelForAssistiveText as u };
